import { __extends } from "tslib";
import { Vector3 } from "../../Maths/math.vector";
import { Mesh } from "../../Meshes/mesh";
import { SceneLoader } from "../../Loading/sceneLoader";
import { WebVRController } from "./webVRController";
import { PoseEnabledControllerType, PoseEnabledControllerHelper } from "./poseEnabledController";
/**
     * Gear VR Controller
     */
var GearVRController = /** @class */ (function (_super) {
    __extends(GearVRController, _super);
    /**
     * Creates a new GearVRController from a gamepad
     * @param vrGamepad the gamepad that the controller should be created from
     */
    function GearVRController(vrGamepad) {
        var _this = _super.call(this, vrGamepad) || this;
        _this._buttonIndexToObservableNameMap = [
            'onPadStateChangedObservable',
            'onTriggerStateChangedObservable' // Trigger
        ];
        _this.controllerType = PoseEnabledControllerType.GEAR_VR;
        // Initial starting position defaults to where hand would be (incase of only 3dof controller)
        _this._calculatedPosition = new Vector3(_this.hand == "left" ? -0.15 : 0.15, -0.5, 0.25);
        _this._disableTrackPosition(_this._calculatedPosition);
        return _this;
    }
    /**
     * Implements abstract method on WebVRController class, loading controller meshes and calling this.attachToMesh if successful.
     * @param scene scene in which to add meshes
     * @param meshLoaded optional callback function that will be called if the mesh loads successfully.
     */
    GearVRController.prototype.initControllerMesh = function (scene, meshLoaded) {
        var _this = this;
        SceneLoader.ImportMesh("", GearVRController.MODEL_BASE_URL, GearVRController.MODEL_FILENAME, scene, function (newMeshes) {
            // Offset the controller so it will rotate around the users wrist
            var mesh = new Mesh("", scene);
            newMeshes[1].parent = mesh;
            newMeshes[1].position.z = -0.15;
            _this._defaultModel = mesh;
            _this.attachToMesh(_this._defaultModel);
            if (meshLoaded) {
                meshLoaded(_this._defaultModel);
            }
        });
    };
    /**
     * Called once for each button that changed state since the last frame
     * @param buttonIdx Which button index changed
     * @param state New state of the button
     * @param changes Which properties on the state changed since last frame
     */
    GearVRController.prototype._handleButtonChange = function (buttonIdx, state, changes) {
        if (buttonIdx < this._buttonIndexToObservableNameMap.length) {
            var observableName = this._buttonIndexToObservableNameMap[buttonIdx];
            // Only emit events for buttons that we know how to map from index to observable
            var observable = this[observableName];
            if (observable) {
                observable.notifyObservers(state);
            }
        }
    };
    /**
     * Base Url for the controller model.
     */
    GearVRController.MODEL_BASE_URL = 'https://controllers.babylonjs.com/generic/';
    /**
     * File name for the controller model.
     */
    GearVRController.MODEL_FILENAME = 'generic.babylon';
    /**
     * Gamepad Id prefix used to identify this controller.
     */
    GearVRController.GAMEPAD_ID_PREFIX = 'Gear VR'; // id is 'Gear VR Controller'
    return GearVRController;
}(WebVRController));
export { GearVRController };
PoseEnabledControllerHelper._ControllerFactories.push({
    canCreate: function (gamepadInfo) {
        return gamepadInfo.id.indexOf(GearVRController.GAMEPAD_ID_PREFIX) === 0 ||
            gamepadInfo.id.indexOf('Oculus Go') !== -1 ||
            gamepadInfo.id.indexOf('Vive Focus') !== -1;
    },
    create: function (gamepadInfo) {
        return new GearVRController(gamepadInfo);
    }
});
//# sourceMappingURL=gearVRController.js.map